export const IMAGE_HOST = "https://cdn.bvote.vn";
